import { use, useEffect, useState } from "react";
// import axios from 'axios';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";
import "dayjs/locale/nl";
import "./Home.css";
// import Cards from '../../components/Cards';
import DiscoverEvent from "../../components/DiscoverEvent";
import Carousel from "../../components/Carousel";
import SearchBar from "../../components/SearchBar";
import EventsList from "../../components/EventsList";
import { adjustTime, isSignupDeadlinePassed } from "../../helpers/helpers";
import NoEvents from "../../components/NoEvents";
import EventItemPreloader from "../../components/EventItemPreloader";
// import eventItems from '../../utils/mockupData.json';
import React from "react";
import { supabase } from "../../supabaseClient";
import LanguageIcon from "../../assets/Language.svg";
import TopBar from "../../components/TopBar";
import { useTranslation } from "react-i18next";
import TrendingEvents from "../../components/TrendingEvents";
import SpinWinEventSection from "../../components/SpinWinEventSection";
import { useSelector } from "react-redux";
import { selectUser } from "../../slices/userReducer";
import { useNavigate } from "react-router-dom";
import {
  getScrollPosition,
  clearScrollPosition,
  getClickedEventId,
  clearClickedEventId,
} from "../../utils/scrollPositions";
import { trackPageViewAnalytics } from "../../utils/visitorTracking";

export const CustomSelect = ({ options, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option) => {
    onSelect(option); // Propagate the selected option to the parent component
    setIsOpen(false); // Close the dropdown
  };

  return (
    <div className="">
      <button
        className="flex justify-between items-center w-full"
        onClick={handleToggleDropdown}
      >
        {/* {selectedOption ? selectedOption.label : "Select an option"} */}
        <img
          src={LanguageIcon}
          className="w-12 h-12 text-white"
          alt="Language Icon"
        />
      </button>
      {isOpen && (
        <ul className="right-[50px] z-10 absolute bg-[#130826] m-0 p-0 rounded-[10px] w-64 list-none">
          {options.map((option) => (
            <li
              key={option.value}
              onClick={() => handleOptionClick(option.value)}
              className="px-4 py-2 text-white cursor-pointer"
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

dayjs.extend(utc);
dayjs.extend(timezone);

const Home = ({
  token,
  eventData,
  genres,
  eventsLoading,
  setEventsLoading,
  language,
  setLanguage,
}) => {
  const user = useSelector(selectUser);

  // Get city from URL query parameter or localStorage
  const [queryParams, setQueryParams] = useState(
    new URLSearchParams(window.location.search)
  );
  const cityFromUrl = queryParams.get("city");
  const capitalizeFirstLetter = (string) => {
    return string
      ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
      : string;
  };

  // Simplified priority system: URL city > token filters > localStorage filters > fallback
  const getDefaultCity = () => {
    if (cityFromUrl) {
      return capitalizeFirstLetter(cityFromUrl);
    }
    // Don't check localStorage yet - let token filters be applied first
    return "Amsterdam"; // Temporary fallback
  };

  const defaultCity = getDefaultCity();

  // Store city from URL in localStorage if present (URL has priority)
  if (cityFromUrl) {
    localStorage.setItem("city", capitalizeFirstLetter(cityFromUrl));
  }

  const [onlineEvents, setOnlineEvents] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [tabLoading, setTabLoading] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [tokenFiltersApplied, setTokenFiltersApplied] = useState(false);

  const [filters, setFilters] = useState({
    datum: "Alle datums",
    categorie: "Alle events",
    genre: [],
    leeftijd: "Alle leeftijden",
    city: defaultCity,
    priceRange: [0, 100],
    currency: "€", // Default currency is Euro
  });

  const [currentCity, setCurrentCity] = useState(defaultCity);

  const [currentNetherlandsTime, setCurrentNetherlandsTime] = useState(() => {
    const netherlandsTime = new Date().toLocaleString("en-US", {
      timeZone: "Europe/Amsterdam",
    });

    return netherlandsTime;
  });

  const formattedCurrentDate = dayjs(currentNetherlandsTime).format(
    "YYYY-MM-DD HH:mm:ss"
  );

  const [trendingEvents, setTrendingEvents] = useState([]);

  // Add this near the top of your Home component, after other state declarations

  const [hasScrolled, setHasScrolled] = useState(false);

  const navigate = useNavigate();

  // Fix localStorage "All_cities" issue
  useEffect(() => {
    const storedCity = localStorage.getItem("city");
    if (storedCity === "All_cities") {
      localStorage.setItem("city", "all_cities");
    }

    // Fix eventFilters localStorage "All_cities" issue
    const storedEventFilters = localStorage.getItem("eventFilters");
    if (storedEventFilters) {
      try {
        const parsedFilters = JSON.parse(storedEventFilters);
        let updated = false;

        // Check if cities array contains "All_cities" string
        if (parsedFilters.cities && Array.isArray(parsedFilters.cities)) {
          if (parsedFilters.cities.includes("All_cities")) {
            parsedFilters.cities = [];
            updated = true;
          }
        }

        // Update localStorage if changes were made
        if (updated) {
          localStorage.setItem("eventFilters", JSON.stringify(parsedFilters));
        }
      } catch (error) {
        console.error("Error parsing eventFilters from localStorage:", error);
      }
    }
  }, []);

  // Add this inside the Home component, after other state declarations
  const [shouldRestoreScroll, setShouldRestoreScroll] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setQueryParams(params);

        // Track page view for analytics
    trackPageViewAnalytics('EVENTS', user?.id || null);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.search]);

  useEffect(() => {
    supabase
      .from("City")
      .select("*")
      .then(({ data, error }) => {
        if (error) {
          console.error(error);
        }
      });

    const timer = setInterval(() => {
      setCurrentNetherlandsTime(() => {
        const netherlandsTime = new Date().toLocaleString("en-US", {
          timeZone: "Europe/Amsterdam",
        });
        return netherlandsTime;
      }); // Update current date and time
    }, 1000); // Update every second (adjust as needed)

    return () => {
      clearInterval(timer); // Clean up the timer when the component unmounts
    };
  }, []);

  useEffect(() => {
    filterAll();
    // setFilteredData(eventData);
    if (eventData.length > 0) {
      setEventsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventData, filters, currentCity]);

  useEffect(() => {
    if (eventData.length > 0) {
      setTrendingEvents(
        filteredData.filter((event) => event.trending === true)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredData, formattedCurrentDate]);

  // First apply URL filters (highest priority)
  useEffect(() => {
    const urlCity = queryParams.get("city");

    // Apply URL city filter immediately if present
    if (urlCity) {
      const capitalizedCity = capitalizeFirstLetter(urlCity);

      setFilters((prev) => ({
        ...prev,
        city: capitalizedCity,
        cities: [capitalizedCity],
      }));
      setCurrentCity(capitalizedCity);

      // Store URL city in localStorage
      localStorage.setItem("city", capitalizedCity);
    }
  }, [queryParams]);

  // Then apply token default filters SECOND
  useEffect(() => {
    const urlToken = queryParams.get("token");

    if (urlToken || user?.token) {
      const fetchTokenDefaultFilters = async () => {
        // Priority: URL token > user.token (but only if no URL token)
        let token = urlToken;

        try {
          const { data, error } = await supabase
            .from("Token")
            .select("default_filters")
            .eq("name", token)
            .single();

          if (error) {
            // console.error("Error fetching token default filters:", error);
            return;
          }

          if (data && data.default_filters) {
            const defaultFilters = data.default_filters;

            // Handle genres
            let genreValue = Array.isArray(defaultFilters.genre)
              ? defaultFilters.genre
              : defaultFilters.genre?.split(",").map((g) => g.trim()) || [];

            const urlCity = queryParams.get("city");

            setFilters((prev) => {
              // Determine the city to use based on priority
              let cityToUse = prev.city;
              let citiesToUse = prev.cities;

              // Priority 1: URL city (don't override if already set from URL)
              if (urlCity) {
                // Keep existing URL city values
                cityToUse = prev.city;
                citiesToUse = prev.cities;
              }
              // Priority 2: Token default city filters (only if no URL city)
              else if (
                defaultFilters.cities &&
                defaultFilters.cities.length > 0
              ) {
                cityToUse = defaultFilters.cities[0];
                citiesToUse = defaultFilters.cities;
              }

              console.log("final cityToUse from token:", cityToUse);
              console.log("final citiesToUse from token:", citiesToUse);

              return {
                datum: defaultFilters.datum || prev.datum,
                categorie: defaultFilters.categorie || prev.categorie,
                genre: genreValue,
                leeftijd: defaultFilters.leeftijd || prev.leeftijd,
                city: cityToUse,
                cities: citiesToUse,
                priceRange: [0, 100],
                currency: "€",
              };
            });

            // Update current city only if no URL city was provided
            if (!urlCity) {
              if (
                defaultFilters.cities &&
                defaultFilters.cities.length > 0
              ) {
                setCurrentCity(defaultFilters.cities[0]);
              }
            }

            // Apply language setting if present
            if (defaultFilters.language) {
              setLanguage(defaultFilters.language);
              localStorage.setItem("language", defaultFilters.language);
            }

            // Handle landing page redirect
            if (
              defaultFilters.landing_page === "deals" &&
              window.location.pathname === "/"
            ) {
              navigate(`/lifestyle${window.location.search}`);
              return;
            }
          }
        } catch (err) {
          // console.error("Error fetching token default filters:", err);
        } finally {
          setTokenFiltersApplied(true);
        }
      };

      fetchTokenDefaultFilters();
    } else {
      setTokenFiltersApplied(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams, user, navigate, window.location.pathname]);

  // Apply localStorage filters only after token filters have been processed
  useEffect(() => {
    if (!tokenFiltersApplied) return;

    const urlCity = queryParams.get("city");

    // Only apply localStorage if no URL city and no token has set the city
    if (!urlCity && !queryParams.get("token") && !user?.token) {
      const storedCity = localStorage.getItem("city");
      if (storedCity && storedCity !== currentCity) {
        setCurrentCity(storedCity);
        setFilters((prev) => ({
          ...prev,
          city: storedCity,
          cities: storedCity.toLowerCase() === "all_cities" ? [] : [storedCity],
        }));
      }
    }

    // Ensure we always have a city in localStorage for future visits
    if (!localStorage.getItem("city")) {
      localStorage.setItem("city", "all_cities");
    }
  }, [tokenFiltersApplied, queryParams, currentCity, user]);

  // Add this function to filter events by venue
  const filterByVenue = (arr) => {
    const selectedVenues = filters["venues"];

    // If no venues are selected, return all events
    if (!selectedVenues || selectedVenues.length === 0) {
      return arr;
    }

    // Filter events that match any of the selected venues
    return arr.filter((event) => {
      if (!event.venue || !event.venue.name) return false;
      return selectedVenues.includes(event.venue.name);
    });
  };

  // Add this function to filter events by price with currency conversion
  const filterByPrice = (arr) => {
    const priceRange = filters.priceRange;
    const selectedCurrency = filters.currency || "€";

    // If no price range is set or it's the default range, return all events
    if (!priceRange || (priceRange[0] === 0 && priceRange[1] === 100)) {
      return arr;
    }

    // Currency conversion rates (approximate)
    const conversionRates = {
      "€": 1, // Euro (base currency)
      "£": 0.85, // British Pound
      Rp: 16500, // Indonesian Rupiah
    };

    // Filter events that fall within the price range
    return arr.filter((event) => {
      // If event has no price, include it when minimum is 0, otherwise exclude it
      if (event.our_price === null || event.our_price === undefined) {
        return priceRange[0] === 0;
      }

      // Convert price to number if it's a string
      const eventPrice =
        typeof event.our_price === "string"
          ? parseFloat(event.our_price)
          : event.our_price;

      // Get the event's currency
      const eventCurrency = event.currency || "€";

      // Convert event price to the selected currency
      let convertedPrice = eventPrice;

      // First convert to EUR (base currency)
      if (eventCurrency !== "€") {
        convertedPrice = eventPrice / conversionRates[eventCurrency];
      }

      // Then convert from EUR to selected currency
      if (selectedCurrency !== "€") {
        convertedPrice = convertedPrice * conversionRates[selectedCurrency];
      }

      // Check if the converted price is within the selected range
      return convertedPrice >= priceRange[0] && convertedPrice <= priceRange[1];
    });
  };

  // Update the filterAll function to include price filtering
  const filterAll = () => {
    const filteredByDates = filterByDate(eventData);
    const filteredByCategory = filterByCategory(filteredByDates);
    const filteredByGenres = filterByGenre(filteredByCategory);
    const filteredByAge = filterByAge(filteredByGenres);
    const filteredByCity = filterByCity(filteredByAge);
    const filteredByVenue = filterByVenue(filteredByCity);
    const filteredByPrice = filterByPrice(filteredByVenue); // Add price filtering

    const filteredByPublished = filteredByPrice.filter((event) => {
      // Use the proper timezone-aware function to check if signup deadline has passed
      return !isSignupDeadlinePassed(event.signup_until);
    });

    setFilteredData(filteredByPublished);
    setOnlineEvents(
      filteredByPrice.filter(
        // Update this to use filteredByPrice
        (event) =>
          formattedCurrentDate < adjustTime(event.signup_from) &&
          event.city === currentCity
      )
    );
  };

  const filterByDate = (
    arr,
    dateFilter = filters["datum"].toLocaleLowerCase()
  ) => {
    let filteredByDates = [];

    const filterStatus = dateFilter;
    // Ensure we're using the same timezone for all date comparisons
    const today = dayjs().tz("Europe/Amsterdam").locale(language);
    const tomorrow = today.add(1, "day");
    const startOfWeek = today.startOf("week");
    const endOfWeek = today.endOf("week");
    const startOfNextWeek = today.add(1, "week").startOf("week");
    const endOfNextWeek = today.add(1, "week").endOf("week");
    const startOfMonth = today.startOf("month");
    const endOfMonth = today.endOf("month");

    // Helper function to safely parse event datetime
    const parseEventDate = (event) => {
      if (!event.datetime) return null;

      // If it's a number, treat as Unix timestamp
      if (typeof event.datetime === "number") {
        return dayjs.unix(event.datetime).tz("Europe/Amsterdam");
      }

      // If it's a string that looks like a number, convert to number first
      if (typeof event.datetime === "string" && /^\d+$/.test(event.datetime)) {
        return dayjs.unix(parseInt(event.datetime, 10)).tz("Europe/Amsterdam");
      }

      // Otherwise try to parse as ISO date
      return dayjs(event.datetime).tz("Europe/Amsterdam");
    };

    switch (filterStatus) {
      case "vandaag":
      case "today": {
        filteredByDates = arr.filter((event) => {
          const eventDate = parseEventDate(event);
          if (!eventDate || !eventDate.isValid()) {
            console.log(`Invalid date for event: ${event.name}`);
            return false;
          }
          return eventDate.isSame(today, "day");
        });
        break;
      }
      case "morgen":
      case "tomorrow": {
        filteredByDates = arr.filter((event) => {
          const eventDate = parseEventDate(event);
          if (!eventDate || !eventDate.isValid()) return false;
          return eventDate.isSame(tomorrow, "day");
        });
        break;
      }
      case "deze week":
      case "this week": {
        filteredByDates = arr.filter((event) => {
          const eventDate = parseEventDate(event);
          if (!eventDate || !eventDate.isValid()) return false;
          return (
            eventDate.isAfter(startOfWeek) &&
            eventDate.isBefore(endOfWeek.add(1, "day"))
          );
        });
        break;
      }
      case "volgende week":
      case "next week": {
        filteredByDates = arr.filter((event) => {
          const eventDate = parseEventDate(event);
          if (!eventDate || !eventDate.isValid()) return false;
          return (
            eventDate.isAfter(startOfNextWeek) &&
            eventDate.isBefore(endOfNextWeek.add(1, "day"))
          );
        });
        break;
      }
      case "deze maand":
      case "this month": {
        filteredByDates = arr.filter((event) => {
          const eventDate = parseEventDate(event);
          if (!eventDate || !eventDate.isValid()) return false;
          return (
            eventDate.isAfter(startOfMonth) &&
            eventDate.isBefore(endOfMonth.add(1, "day"))
          );
        });
        break;
      }
      default:
        filteredByDates = arr;
        break;
    }

    return filteredByDates;
  };

  const filterByCategory = (arr) => {
    let filteredByCategory = [];
    const filterStatus = filters["categorie"].toLowerCase();
    switch (filterStatus) {
      case "dag event":
      case "day event":
        filteredByCategory = arr.filter(
          (event) =>
            event.event_type.toLowerCase() === "day event" ||
            event.event_type.toLowerCase() === "dag event"
        );
        break;
      case "nacht event":
      case "night event":
        filteredByCategory = arr.filter(
          (event) =>
            event.event_type.toLowerCase() === "night event" ||
            event.event_type.toLowerCase() === "nacht event"
        );
        break;
      case "festival":
        filteredByCategory = arr.filter(
          (event) => event.event_type.toLowerCase() === "festival"
        );
        break;
      default:
        filteredByCategory = arr;
        break;
    }

    return filteredByCategory;
  };

  const filterByGenre = (arr) => {
    const filterStatus = filters["genre"]?.map((genre) => genre.toLowerCase()); // array

    // If no genres are selected, return all events
    if (!filterStatus || filterStatus.length === 0) {
      return arr;
    }

    // Filter events that have at least one of the selected genres
    return arr.filter((event) => {
      if (!event.genres) return false;

      const eventGenres = event.genres
        .split(",")
        .map((genre) => genre.trim().toLowerCase());

      return eventGenres.some((eventGenre) =>
        filterStatus.includes(eventGenre.toLowerCase())
      );
    });
  };

  const filterByAge = (arr) => {
    let filteredByAge = [];
    const filterStatus = filters["leeftijd"];

    switch (filterStatus) {
      case "18+":
        filteredByAge = arr.filter((event) => +event.minimum_age <= 18);
        break;
      case "21+":
        filteredByAge = arr.filter(
          (event) => +event.minimum_age <= 21 && +event.minimum_age > 18
        );
        break;
      case "23+":
        filteredByAge = arr.filter(
          (event) => +event.minimum_age <= 23 && +event.minimum_age > 21
        );
        break;
      default:
        filteredByAge = arr; // "All ages" shows all events
        break;
    }
    return filteredByAge;
  };

  const filterByCity = (arr) => {
    let filteredByCity = [];

    // Handle both array (filters.cities) and string (filters.city) cases
    const citiesArray = filters.cities || [];
    const singleCity = filters.city;

    if (
      citiesArray.length === 0 ||
      (singleCity && singleCity.toLowerCase() === "all_cities")
    ) {
      // If no cities selected or explicitly set to all_cities, show all events
      filteredByCity = arr;
    } else if (citiesArray.length > 0) {
      // Filter by multiple cities (from DiscoverEvent component)
      filteredByCity = arr.filter((event) =>
        citiesArray.some((city) => event.city.includes(city))
      );
    } else {
      // Filter by single city (from sidebar)
      filteredByCity = arr.filter((event) => event.city.includes(singleCity));
    }

    return filteredByCity;
  };

  const changeCity = (city) => {
    localStorage.setItem("city", city);

    setTabLoading(true);
    setFilters((prev) => ({
      ...prev,
      city: city,
      // Also update the cities array to match the selected city
      // cities: city === "all_cities" ? [] : [city],
    }));
    setCurrentCity(city);

    filterAll();

    setTimeout(() => {
      setTabLoading(false);
    }, 200);
  };

  const { t } = useTranslation();

  const showOnlineEventsSection = onlineEvents.length > 0;

  useEffect(() => {
    // Try to detect scrolling in any element
    const handleScrollAnywhere = () => {
      // Get scroll position from the documentElement (most reliable cross-browser)
      const windowScroll =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;

      // Check if window is at the very top (0 position)
      if (windowScroll <= 0) {
        // Only check containers if window is at the top
        const containers = document.querySelectorAll(".scroller");
        let containerScrolled = false;

        containers.forEach((container) => {
          if (container.scrollTop > 0) {
            containerScrolled = true;
          }
        });

        // If window is at top and no containers are scrolled, immediately set hasScrolled to false
        if (!containerScrolled) {
          setHasScrolled(false);
        }
      } else {
        // If window is scrolled, immediately set hasScrolled to true
        setHasScrolled(true);
      }
    };

    // Initial check
    handleScrollAnywhere();

    // Add multiple event listeners to catch all possible scroll events
    window.addEventListener("scroll", handleScrollAnywhere, { passive: true });
    document.addEventListener("scroll", handleScrollAnywhere, {
      passive: true,
    });

    // Force checking the scroll position at regular intervals
    const intervalId = setInterval(handleScrollAnywhere, 10);

    // Also apply a fallback class after some time has passed
    const timeoutId = setTimeout(() => {
      if (!hasScrolled) {
        setHasScrolled(true);
      }
    }, 5000);

    return () => {
      window.removeEventListener("scroll", handleScrollAnywhere);
      document.removeEventListener("scroll", handleScrollAnywhere);
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, [hasScrolled]);

  const getCityDisplayText = (cities) => {
    if (!cities || cities.length === 0) return t("all_cities");
    if (cities.length === 1) return cities[0];
    return t("multiple_cities", { count: cities.length });
  };

  // Update the filterFunctions object to include the price filter
  const filterFunctions = {
    filterByDate,
    filterByCategory,
    filterByGenre,
    filterByAge,
    filterByCity,
    filterByVenue,
    filterByPrice, // Add the price filter function
  };

  // Enhanced scroll restoration with event ID tracking
  useEffect(() => {
    if (shouldRestoreScroll) {
      const scrollY = getScrollPosition("home-page");
      const clickedEventId = getClickedEventId();

      if (clickedEventId) {
        // Use MutationObserver to watch for DOM changes (indicating expansion is complete)
        let observer;
        let attempts = 0;
        const maxAttempts = 8;

        const scrollToEvent = () => {
          const eventElement = document.querySelector(
            `[data-event-id="${clickedEventId}"]`
          );
          if (eventElement) {
            // Clean up observer
            if (observer) {
              observer.disconnect();
            }

            // Wait a bit more to ensure DOM is fully rendered
            setTimeout(() => {
              eventElement.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest",
              });
            }, 150);
            clearClickedEventId();
            clearScrollPosition("home-page");
            return true;
          }
          return false;
        };

        const tryScroll = () => {
          attempts++;
          if (scrollToEvent()) {
            return; // Success!
          }

          if (attempts < maxAttempts) {
            // Use exponential backoff: 200ms, 400ms, 800ms, etc.
            const delay = Math.min(200 * Math.pow(1.5, attempts - 1), 2000);
            setTimeout(tryScroll, delay);
          } else {
            // Final fallback to scroll position after all attempts
            if (observer) {
              observer.disconnect();
            }
            if (scrollY > 0) {
              window.scrollTo({
                top: scrollY,
                behavior: "smooth",
              });
            }
            clearScrollPosition("home-page");
            clearClickedEventId();
          }
        };

        // Set up MutationObserver to watch for DOM changes
        const eventsContainer = document.querySelector(".zoek-evenementen");
        if (eventsContainer) {
          observer = new MutationObserver((mutations) => {
            // Check if significant DOM changes occurred
            const hasSignificantChanges = mutations.some(
              (mutation) =>
                mutation.type === "childList" && mutation.addedNodes.length > 0
            );

            if (hasSignificantChanges) {
              // DOM changed, try to scroll again
              setTimeout(() => {
                if (!scrollToEvent()) {
                  tryScroll();
                }
              }, 100);
            }
          });

          observer.observe(eventsContainer, {
            childList: true,
            subtree: true,
          });
        }

        // Start the retry process
        tryScroll();
      } else if (scrollY > 0) {
        // Normal scroll position restoration
        setTimeout(() => {
          window.scrollTo({
            top: scrollY,
            behavior: "smooth",
          });
          clearScrollPosition("home-page");
        }, 100);
      }
      setShouldRestoreScroll(false);
    }
  }, [shouldRestoreScroll, filteredData]); // Add filteredData as dependency to trigger after events load

  // Add this useEffect to clear scroll positions on page refresh
  useEffect(() => {
    const handleBeforeUnload = () => {
      // Clear all scroll positions and event ID when the page is refreshed
      clearScrollPosition("home-page");
      clearClickedEventId();
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <div className="relative bg-[#2a0744] min-h-screen">
      <div className="relative flex flex-col justify-center items-center bg-[#0B0415]">
        <div className="relative lg:w-[95%] max-lg:w-[100vw] max-w-[1400px]">
          {/* Add a placeholder div that takes up space when the header is fixed */}
          <div
            className={`max-lg:h-[70px] transition-all duration-300 opacity-0`}
          />

          <TopBar
            setLanguage={setLanguage}
            eventData={eventData}
            formattedCurrentDate={formattedCurrentDate}
            hasScrolled={hasScrolled}
          />

          <div className={`transition-all max-lg:pb-[20px] lg:py-[60px]`}>
            <div
              className={`max-lg:z-[99999] max-lg:bg-[#12041f] transition-all max-lg:fixed max-lg:left-0 max-lg:right-0 max-lg:w-full flex items-center justify-between ${
                hasScrolled ? "mt-[-15px] max-lg:backdrop-blur-lg" : ""
              }`}
            >
              <div className="flex justify-start items-center gap-3 max-lg:pb-2 max-lg:w-full max-lg:overflow-x-auto max-lg:scrollbar-hide">
                {/* Filters */}
                <DiscoverEvent
                  filters={filters}
                  setFilters={setFilters}
                  token={token}
                  city={currentCity}
                  genres={genres}
                  changeCity={changeCity}
                />
              </div>
              <div className="max-lg:hidden flex justify-end items-center gap-3">
                {/* Search Bar */}
                <SearchBar
                  eventData={eventData}
                  formattedCurrentDate={formattedCurrentDate}
                  onSearchDismiss={() => {}}
                  isSearchActive={isSearchActive}
                  setIsSearchActive={setIsSearchActive}
                />
              </div>
            </div>
            <h1 className="max-lg:px-[16px] pt-[60px] lg:pt-[60px] w-full text-[36px] text-white lg:text-[72px] text-start leading-[40px] lg:leading-[80px]">
              {t("guestlist")} & Community tickets in{" "}
              <br className="max-lg:hidden" />
              <span className="text-[#C9A6F5]">
                {getCityDisplayText(filters.cities)}
              </span>
            </h1>
          </div>
          <hr className="right-0 left-0 absolute border-[#AD7AEF80] border-r w-full" />
        </div>

        <div
          className="flex justify-center w-full min-h-[66.6vh] scroller"
          style={{
            background:
              "linear-gradient(to bottom, #0B0415 0%, #1d0630 40vh, #2a0744 60vh)",
          }}
        >
          <div className="lg:w-[95%] max-lg:w-[100vw] max-w-[1400px]">
            <h2 className="max-lg:hidden max-lg:!px-[16px] pt-[50px] text-white">
              {t("discover_events")}
            </h2>

            {/* Spin & Win Events Section - Only visible to admins */}
            {!isSearchActive && (
              <SpinWinEventSection
                formattedCurrentDate={formattedCurrentDate}
                filters={filters}
                currentCity={currentCity}
                filterFunctions={filterFunctions}
              />
            )}

            {trendingEvents.length > 0 && (
              <div className="mt-[24px] lg:mt-[32px]">
                <TrendingEvents trendingEvents={trendingEvents} />
              </div>
            )}

            <section className="max-lg:!px-[16px] !pb-[80px] zoek-evenementen">
              {eventsLoading || tabLoading ? (
                <div className="w-full">
                  <EventItemPreloader />

                  {/* {isDivider && ( */}
                  <div className="card-divider"></div>
                  {/* )} */}
                </div>
              ) : filteredData.length > 0 ? (
                <>
                  <EventsList
                    eventsData={filteredData}
                    currentCity={currentCity}
                    isDivider={showOnlineEventsSection}
                    formattedCurrentDate={formattedCurrentDate}
                    language={language}
                    cities={filters.cities}
                  />
                </>
              ) : (
                <>
                  <NoEvents />
                </>
              )}

              {/* <NoEvents /> */}
            </section>
            {showOnlineEventsSection && (
              <section className="pb-[80px]">
                <Carousel
                  onlineEvents={onlineEvents}
                  city={currentCity}
                  formattedCurrentDate={formattedCurrentDate}
                />
              </section>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Home;
